exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-title{\n  /* background-color: #fdf8ff; */\n  font-weight: bold;\n}\n.text-row{\n  font-size: 0.5rem !important;\n}\n.title-list{\n  font-weight: 500;\n}\n.item-list{\n  font-size: 0.7rem\n}\n.vs-icon.notranslate.icon-scale.feather.icon-check.null{\n  color: green;\n}\n.vs-icon.notranslate.icon-scale.feather.icon-clock.null{\n  color: red;\n}  \n", ""]);

// exports
